import classes from './ProgressBar.module.css';

const ProgressBar = ({ duration = 3000, color = '#D72F19', width = '200px', className }) => {
    return (
        <div className={`${classes.progressBarContainer} ${className || ''}`}>
            <div className={classes.progressBar} style={{ width }}>
                <div 
                    className={classes.progressBarFill}
                    style={{ 
                        backgroundColor: color,
                        '--progress-duration': `${duration}ms`
                    }}
                ></div>
            </div>
        </div>
    );
};

export default ProgressBar;

